import { Component } from 'react';
import styled from 'styled-components';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_STYLES = {
  circle_color: 'circle_color',
  circle_black: 'circle_black',
  circle_grey: 'circle_grey',
  original_black: 'original_black',
  square_color: 'square_color',
  square_black: 'square_black',
  square_grey: 'square_grey'
};
const IconButtonsContainer = styled.div.withConfig({
  displayName: "SocialIconStyleField__IconButtonsContainer",
  componentId: "sc-92g3se-0"
})(["display:flex;flex-wrap:wrap;margin-left:-11px;margin-bottom:-11px;"]);
const IconButtonWrapper = styled.div.withConfig({
  displayName: "SocialIconStyleField__IconButtonWrapper",
  componentId: "sc-92g3se-1"
})(["margin-left:11px;margin-bottom:11px;"]);
const IconButton = styled(UISelectableBox).attrs({
  flush: true,
  width: 59,
  height: 58
}).withConfig({
  displayName: "SocialIconStyleField__IconButton",
  componentId: "sc-92g3se-2"
})([""]);
const IconImage = styled.img.withConfig({
  displayName: "SocialIconStyleField__IconImage",
  componentId: "sc-92g3se-3"
})(["width:40px;height:40px;margin-left:0;margin-top:9px;"]);

// TODO: Figure out real solution for where icon images should come from
const getStyleIconSrc = styleName => `https://static.hsstatic.net/TemplateAssets/static-1.17/img/hs_default_template_images/modules/Follow%20Me%20-%20Email/facebook_${styleName}.png`;
class SocialIconStyleField extends Component {
  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'readOnly' does not exist on type 'Readon... Remove this comment to see the full error message
    const {
      readOnly,
      value
    } = this.props;
    return /*#__PURE__*/_jsx(IconButtonsContainer, {
      children: Object.keys(ICON_STYLES).map(styleName => /*#__PURE__*/_jsx(IconButtonWrapper, {
        children: /*#__PURE__*/_jsx(IconButton, {
          onSelectedChange: () => this.props.onFieldChange(styleName),
          selected: value === styleName,
          readOnly: readOnly,
          children: /*#__PURE__*/_jsx(IconImage, {
            src: getStyleIconSrc(styleName)
          })
        })
      }, styleName))
    });
  }
}
export default SocialIconStyleField;